import React from 'react';
import PropTypes from 'prop-types';
import KpiTable from '../../../commons/KpiTable';

const PartnerLicensePackageUsageRateTable = (props) => (
  <KpiTable
    title="License package usage"
    description="The number represents the percentage of usage of the contracted license packages. It is important that the percentage is close to or greater than 100% because customers are paying for licenses."
    loading={props.loading}
    values={props.values}
    currentHigherIsBetter={true}
    onSelect={props.onSelect}
    formatter={props.formatter}
    feedbackColorRender={props.feedbackColorRender}
    additionalColumns={[
      {
        label: 'Standard Deviation',
        path: 'currentStandardDeviation',
      },
      {
        label: 'Total of Registers',
        path: 'currentAmount',
      },
    ]}
  />
);

PartnerLicensePackageUsageRateTable.propTypes = {
  onSelect: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  values: PropTypes.array.isRequired,
  formatter: PropTypes.func.isRequired,
  feedbackColorRender: PropTypes.func.isRequired,
};

export default PartnerLicensePackageUsageRateTable;
